import { useEffect, useState, useLayoutEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { fetchCourse,orderLessonPositions } from "../../api/courses/teachers";
import { fetchLessons, createLesson, deleteLesson } from "../../api/lessons/teachers";
import TeacherSidebar from "../../components/Dashboard/TeacherSidebar";
import BackButton from "../../components/Shared/BackButton";
import { Button } from "../../components/Shared/Button";
import TeacherNavbar from "../../components/TeacherNavbar";

import { monthAbbr } from "../../utils";

import "./index.css";

function PlusIcon() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.33325 4.33325V0.333252H5.66659V4.33325H9.66659V5.66659H5.66659V9.66659H4.33325V5.66659H0.333252V4.33325H4.33325Z" fill="white"/>
    </svg>
  )
}

function EditIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.4561 17.0358H17.4999" stroke="#0D3A5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.65 3.16233C11.2964 2.38982 12.4583 2.27655 13.2469 2.90978C13.2905 2.94413 14.6912 4.03232 14.6912 4.03232C15.5575 4.55599 15.8266 5.66925 15.2912 6.51882C15.2627 6.56432 7.34329 16.4704 7.34329 16.4704C7.07981 16.7991 6.67986 16.9931 6.25242 16.9978L3.21961 17.0358L2.53628 14.1436C2.44055 13.7369 2.53628 13.3098 2.79975 12.9811L10.65 3.16233Z" stroke="#0D3A5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.18408 5.00073L13.7276 8.49" stroke="#0D3A5D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

function TrashIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.708 6.23975H3.75" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

function MoveUpIcon() {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.36148 7.75L7.63836 7.75C8.79605 7.75 9.51736 6.49418 8.93403 5.4942L6.29559 0.971146C5.71677 -0.0211123 4.28307 -0.0211138 3.70425 0.971144L1.06581 5.49419C0.482483 6.49418 1.20379 7.75 2.36148 7.75Z" fill="#131313"/>
    </svg>
  );
}

function MoveDownIcon() {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.63852 0.25L2.36164 0.25C1.20395 0.25 0.482641 1.50582 1.06597 2.5058L3.70441 7.02885C4.28323 8.02111 5.71693 8.02111 6.29575 7.02886L8.93419 2.50581C9.51752 1.50582 8.79621 0.25 7.63852 0.25Z" fill="#131313"/>
    </svg>
  );
}

function TeacherCourseBuilder() {
  const navigate = useNavigate();
  const [course, setCourse] = useState({})
  const [lessons, setLessons] = useState([]);

  const { courseId } = useParams();
  useEffect(async () => {
    try {
      const res = await fetchCourse(courseId);
      setCourse(res);
    } catch (err) {
      console.log(err);
    }
  }, [])

  useEffect(async () => {
    try {
      const res = await fetchLessons(courseId);
      setLessons(res);
    } catch (err) {
      console.log(err);
    }
  }, [])

  useEffect(() => document.body.style.backgroundColor = "#F5F5F5", []);
  useLayoutEffect(() => { return () => document.body.style.backgroundColor = null }, []);

  function prettyDate() {
    const d = new Date(course.updated_at);

    function hoursAs12(date) { return date.getHours() % 12 || 12; }

    function twoDigitMinutes(date) { return String(date.getMinutes()).padStart(2, "0"); }

    function getTime() {
      const t = `${hoursAs12(d)}:${twoDigitMinutes(d)}`;
      const meridiem = d.getHours() > 12 ? "PM" : "AM";

      return `${t} ${meridiem}`
    }

    return `
      ${monthAbbr[d.getMonth()]}, ${d.getDate()} ${d.getFullYear()} at ${getTime()}
    `;
  }

  async function createAndNavToLesson() {
    try {
      const body = {
        lesson: {
          course_id: parseInt(courseId),
          title: `Lesson ${lessons.length + 1}`,
          description: "",
        },
        lessonModules: []
      }
      const res = await createLesson(body);
      navigate(`/teacher/lessons/${res.id}/edit`)
    } catch (err) {
      console.log(err)
    }
  }

  async function onDeleteLesson(lessonId) {
    const ok = window.confirm("Are you sure you want to delete this lesson?")
    if (ok) {
      try {
        await deleteLesson(lessonId);
        const newLessons = [...lessons];
        newLessons.splice(lessons.findIndex(l => l.id === lessonId), 1);
        setLessons(newLessons);
      } catch(err) {
        console.log(err)
      }
    }
  }

  async function orderLessons(lessons) {
    const body = {
      course: {
        id: courseId,
        lessons: lessons,
      },
      courseId: courseId,
    }

    try {
      await orderLessonPositions(courseId, body);
    } catch(err) {
      console.log(err)
    }    
  }

  function onSwapWidgetPositionUp(i) {
    const { position } = lessons[i];
    const idx = position - 1;
    if (idx === 0) {
      return;
    }
    const arr = [...lessons];
    var a = arr[idx];
    arr[idx] = arr[idx - 1];
    arr[idx - 1] = a;

    var b = arr[idx].position;
    arr[idx].position = arr[idx - 1].position;
    arr[idx - 1].position = b;
    setLessons(arr);
    orderLessons(arr);
  }

  function onSwapWidgetPositionDown(i) {
    const { position } = lessons[i];
    const idx = position - 1;
    if (idx >= lessons.length - 1) {
      return;
    }
    const arr = [...lessons];
    var a = arr[idx];
    arr[idx] = arr[idx + 1];
    arr[idx + 1] = a;

    var b = arr[idx].position;
    arr[idx].position = arr[idx + 1].position;
    arr[idx + 1].position = b;
    setLessons(arr);
    orderLessons(arr);
  }
  
  const { title, hero_image_url } = course;
  return (
    <>
      <div className="TeacherDashboardMainContainer">
        <TeacherSidebar />
        <TeacherNavbar />
        <div className="TeacherCourseBuilderContainer" >
          <BackButton
            onClick={() => navigate("/teacher/dashboard")}
          />
          <br />
          <div className="TeacherCourseBuilder">
            <div className="TeacherCourseBuilderHeaderContainer">
              <div
                className="TeacherCourseBuilderHeaderImg"
                style={{ backgroundImage: `url("${hero_image_url}")`}}
              />
              <div className="TeacherCourseBuilderHeader">
                <div className="TeacherCourseBuilderHeaderTitle">{title}</div>
                <div className="TeacherCourseBuilderHeaderSubTitle">
                  {prettyDate()}
                </div>
              </div>
            </div>

            <div className="TeacherCourseBuilderTabs">
              <div className="TeacherCourseBuilderTab">
                <div className="TeacherCourseBuilderTabText">Details</div>
              </div>
            </div>
            <div className="TeacherCourseContentContainer">
              <div className="TeacherCourseContentHeader">
                <div className="TeacherCourseContentHeaderTitle">
                  <div className="TeacherCourseContentHeaderTitleTag" />
                  <div className="TeacherCourseContentHeaderTitleText">Lessons</div>
                </div>
                <div className="TeacherCourseContentHeaderAction">
                  <Button
                    text="Add Lesson"
                    onClick={createAndNavToLesson}
                    Icon={() => <PlusIcon />}
                  />
                </div>
              </div>
            </div>

            <div className="TeacherCourseBuilderLessons">
              {lessons.map(({
                id,
                title,
              }, idx) => (
                <div className="TeacherCourseBuilderLesson">
                  <div className="TeacherCourseBuilderLessonTitle">{title}</div>
                  <div className="TeacherCourseBuilderLessonActions">
                    <div className="TeacherCourseBuilderLessonActionsDrag">
                      <div onClick={() => onSwapWidgetPositionUp(idx)}>
                        <MoveUpIcon />
                      </div>
                      <div onClick={() => onSwapWidgetPositionDown(idx)}>
                        <MoveDownIcon />
                      </div>
                    </div>
                    <div
                      onClick={() => onDeleteLesson(id)}
                      className="TeacherCourseBuilderLessonActionsDelete"
                    >
                      <TrashIcon />
                    </div>
                    <div className="TeacherCourseBuilderLessonActionsEdit">
                      <Button
                        text="Edit"
                        onClick={() => navigate(`/teacher/lessons/${id}/edit`)}
                        Icon={() => <EditIcon />}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TeacherCourseBuilder;
